import { render, staticRenderFns } from "./ProductosPresentacionRango.vue?vue&type=template&id=5c218c96&"
import script from "./ProductosPresentacionRango.vue?vue&type=script&lang=js&"
export * from "./ProductosPresentacionRango.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports